var render, staticRenderFns
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c131c7')) {
      api.createRecord('63c131c7', component.options)
    } else {
      api.reload('63c131c7', component.options)
    }
    
  }
}
component.options.__file = "resources/views/common/object/component/form/elementLp1/stepGroup/component.vue"
export default component.exports